import axios from 'axios';
import { getDemoCrudChar2ApiUrl } from '../../../config/api';

export default class DemoCrudChar2Service {
  constructor() {
    this.registros = [];
    this.loading = false;
    this.error = null;
    this.sortField = null;
    this.sortDirection = 'asc';
    this.currentPage = 1;
    this.itemsPerPage = 10;
  }

  // Inicializar el servicio
  async initialize() {
    await this.listar();
  }

  // Listar registros
  async listar() {
    this.loading = true;
    this.error = null;

    console.log('Cargando registros de DemoCrudChar2...');
    
    try {
      const response = await axios.post(getDemoCrudChar2ApiUrl('/api/DemoCrudChar2/listar'), {});
      
      this.registros = response.data || [];
      this.loading = false;
      
      return {
        success: true,
        data: this.registros,
        message: 'Registros cargados exitosamente'
      };
    } catch (error) {
      console.error('Error al cargar registros:', error);
      this.error = 'No se pudieron cargar los registros. Por favor, intente nuevamente.';
      this.loading = false;
      throw error;
    }
  }

  // Guardar registro (insert/update)
  async guardar(registro) {
    try {
      console.log('Guardando registro:', registro);
      
      const response = await axios.post(getDemoCrudChar2ApiUrl('/api/DemoCrudChar2/guardar'), registro);
      
      // Recargar la lista después de guardar
      await this.listar();
      
      return {
        success: true,
        data: response.data,
        message: 'Registro guardado exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar registro:', error);
      throw error;
    }
  }

  // Leer un registro específico
  async lectura(demoChar, empresaId) {
    try {
      console.log('Leyendo registro:', demoChar, empresaId);
      
      const response = await axios.post(getDemoCrudChar2ApiUrl('/api/DemoCrudChar2/lectura'), {
        DemoChar: demoChar,
        EmpresaId: empresaId
      });
      
      return {
        success: true,
        data: response.data,
        message: 'Registro encontrado'
      };
    } catch (error) {
      console.error('Error al leer registro:', error);
      throw error;
    }
  }

  // Borrar registro
  async borrar(demoChar, empresaId) {
    try {
      console.log('Eliminando registro:', demoChar, empresaId);
      
      const response = await axios.post(getDemoCrudChar2ApiUrl('/api/DemoCrudChar2/borrar'), {
        DemoChar: demoChar,
        EmpresaId: empresaId
      });
      
      // Recargar la lista después de eliminar
      await this.listar();
      
      return {
        success: true,
        data: response.data,
        message: 'Registro eliminado exitosamente'
      };
    } catch (error) {
      console.error('Error al eliminar registro:', error);
      throw error;
    }
  }

  // Recargar registros
  async recargar() {
    console.log('Recargando registros...');
    await this.listar();
  }
}
